// Only these fixed product labels may be mapped. Arbitrary DOM text is never exported.
const knownControls:Record<string,string>={
 '공유하기':'share','공유 링크 준비 중':'share','로그인하기':'login','로그인':'login',
 'Google로 로그인':'login.google','Apple로 로그인':'login.apple','로그인 창 닫기':'login.close',
 '카드':'view.cards','목록':'view.list','전체':'filter.all','국내주식':'filter.kr','미국주식':'filter.us',
 '검색어 지우기':'search.clear','전체 보고서 보기':'filter.reset','보고서 정렬':'sort','내 보고서 정렬':'sort',
 '이전':'previous','다음':'next','닫기':'close','사용법 닫기':'tutorial.close','다시 보기':'retry',
 '종목 검색하기':'search.open','보고서 확인하기':'report.open','보고서 펼치기':'report.open','읽던 곳부터 이어 읽기':'report.resume',
 'Pro 구독하기':'subscribe','결제창을 여는 중':'subscribe','결제 다시 확인하기':'payment.retry','가격 다시 확인하기':'pricing.retry',
 '새 보고서 만들기':'report.new','새 종목 분석하기':'report.new','바이트 사용법':'tutorial.open','바이트란?':'about',
 '내 보관함 확인하기':'collection','내 보관함':'collection','홈':'home','크레딧 충전하기':'credits.topup'
};
/** Labels never contain arbitrary text, form values, account names or URL parameters. */
export function biteActionLabel(element:HTMLElement):string{
 const explicit=element.dataset.track;
 if(explicit)return explicit;
 const kind=element.tagName.toLowerCase();
 const owner=element.closest('[class*="bite-"],[class*="bd-"]');
 const component=Array.from(owner?.classList||[]).find(value=>/^(bite|bd)-[a-z0-9_-]+$/.test(value))||'control';
 const label=(element.getAttribute?.('aria-label')||element.textContent||'').replace(/\s+/g,' ').trim();
 const action=knownControls[label];
 return `bite.action.${kind}.${component}${action?'.'+action:''}`;
}
